// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>61</span>&nbsp;&nbsp;Though the cords of the wicked entangle me,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I do not forget your law.<br> </p> </div></div>";
// Exports
module.exports = code;